import styles from './NotFoundView.module.css';

const NotFoundView = () =>
{
	return (
		<div className={styles.view}>
			<h1>Not found 404</h1>
		</div>
	);
};

export default NotFoundView;